import { ClipboardPayload, CLIPBOARD_TYPE } from './types';

function isValidPayload(data: unknown): data is ClipboardPayload {
  if (!data || typeof data !== 'object') return false;
  const d = data as Record<string, unknown>;
  return d.type === CLIPBOARD_TYPE
    && typeof d.version === 'number'
    && typeof d.bookId === 'number'
    && typeof d.storyId === 'number'
    && Array.isArray(d.branchIds)
    && d.branchIds.length > 0
    && d.branchIds.every((id: unknown) => typeof id === 'number')
    && Array.isArray(d.branchNames)
    && d.branchNames.every((n: unknown) => typeof n === 'string');
}

export async function writeClipboard(payload: ClipboardPayload): Promise<void> {
  await navigator.clipboard.writeText(JSON.stringify(payload));
}

export async function readClipboard(): Promise<ClipboardPayload | null> {
  try {
    const text = await navigator.clipboard.readText();
    const parsed = JSON.parse(text);
    if (isValidPayload(parsed)) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}

export function isSameBook(payload: ClipboardPayload, currentBookId: number): boolean {
  return payload.bookId === currentBookId;
}

